module.exports = "varying vec2 texCoord;\nvoid main() {\ngl_Position = vec4(vertex, 0.0, 1.0);\ntexCoord = tex;\n}"